/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 */

export const LOAD_LIST_PAYMENT_HISTORY_REQUEST =
    '@@b2b_portal_ui/widgetPaymentHistory/LOAD_LIST_PAYMENT_HISTORY_REQUEST';
export const LOAD_LIST_PAYMENT_HISTORY_SUCCESS =
    '@@b2b_portal_ui/widgetPaymentHistory/LOAD_LIST_PAYMENT_HISTORY_SUCCESS';
export const LOAD_LIST_PAYMENT_HISTORY_FAIL =
    '@@b2b_portal_ui/widgetPaymentHistory/LOAD_LIST_PAYMENT_HISTORY_FAIL';
export const CLEAN_LIST_PAYMENT_HISTORY =
    '@@b2b_portal_ui/widgetPaymentHistory/CLEAN_LIST_PAYMENT_HISTORY';
